import React, { useState } from "react";
import "./NewsLetter.css";
import { callMultipleApis } from "../../services/ApiServices";


const userSubscribeURL = process.env.REACT_APP_SUBSCRIBE_URL;

const NewsLetter = () => {
  const [subscribedEmail, setSubscribedEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  const changeHandler = (e) => {
    const value = e.target.value;
    setIsEmailValid(validateEmail(value));
    setSubscribedEmail(value);
  };

  const addSubscriber = async () => {
    if (isEmailValid && subscribedEmail.trim() !== "") {

      try {
        const data = {
          email: subscribedEmail
        };

        const [resSubscription] = await callMultipleApis([
          {
            url: userSubscribeURL,
            method: "POST",
            data: data,
            params: {},
            headers: {},
          }
        ]);

        if (resSubscription.status === true) {
          alert(resSubscription.message);
          setSubscribedEmail("");
        } else {
          alert(resSubscription.message);
        }
      } catch (error) {
        console.error("Error :", error);
      }

    } else {
      alert("Please enter a valid email!");
    }
  };

  return (
    <div className="newsletter">
      <h1>Get Exclusive Offers On Your Email</h1>
      <p>Subscribe to our newsletter and stay updated</p>
      <div>
        <input
          type="email"
          placeholder="Enter Your Email Id"
          required
          value={subscribedEmail}
          onChange={changeHandler}
        />
        <button onClick={addSubscriber}>Subscribe</button>
      </div>
    </div>
  );
};

export default NewsLetter;
